import { shop as EnUsShop } from '../en-us/shop';
import { AgResourceLanguage } from '../types';

export const shop: AgResourceLanguage['shop'] = {
  ...EnUsShop,
  title: 'Boutique AG1',
  category: 'Catégorie',
  allProducts: 'Tous les produits',
  gifts: 'Cadeaux',
  supplements: 'Suppléments',
  subscriptions: 'Abonnements',
  accessories: 'Accessoires',
  gear: 'Équipement',
  button: {
    addToCart: 'Ajouter au panier',
    addToNextOrder: 'Ajouter à la prochaine commande',
    subscribe: 'S’abonner',
    addedToNextOrder: 'Ajouté à la prochaine commande'
  },
  singleSubscription: 'Abonnement unique',
  doubleSubscription: 'Double abonnement',
  description30: '30 portions',
  description60: '60 portions, meilleure valeur',
  descriptionIndividual30: '30 portions individuelles',
  scoopAvailabilityInfo:
    '*Disponible à ajouter au panier lorsque vous avez au moins un autre produit dans le panier',
  scoopPrompt: 'Besoin d’une cuillère avec votre sac ? Ajoutez-la gratuitement ci-dessous.'
};
